<template>
  <div>
    <el-card shadow="hover">
     <div slot="header">
        <el-row>
          <el-col :span="22" style="padding-top: 5px">Gene centric distribution</el-col>
          <el-col :span="2">
            <span>
              <el-tooltip content="Explore more" placement="top" :enterable="false">
                <el-button circle size="mini" @click="handleModalOpen"><i class="fas fa-icon-expand"></i></el-button>
              </el-tooltip>
            </span>
          </el-col>
        </el-row>
      </div>
      <modal-unit-area-tss-distribution :index="index" :series="areaOptions" height="300px"></modal-unit-area-tss-distribution>
    </el-card>
  </div>
</template>

<script>
  import 'echarts/theme/shine.js';
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js'
  import { repeatFrequency, tssHistData } from '../scripts/utils.js';
  import ModalUnitAreaTssDistribution from '../components/ModalUnitAreaTssDistribution.vue'
  const _ = require('lodash');

  export default {
    name: 'MainPlotAreaTssDistribution',
    props: {
      info: Object,
      index: Number
    },
    components: { ModalUnitAreaTssDistribution },
    computed: {
      areaOptions: function () {
        const plotdata = this.info.AnnoInfo.TSSDist;
        const frequencydata = this.info.RepInfo.PlotData;
        const repeats = repeatFrequency(frequencydata, 5, 'descending', 'freq').map(d => { return d.name; });
        const bins = this.info.AnnoInfo.TSSHistBinEdges;
        const tssData = tssHistData(plotdata, bins, repeats, 500);

        const series = [];
        for (let rep of repeats) {
            let obj = {};
            obj.name = rep;
            obj.type = 'line';
            obj.data = tssData.data[rep];
            obj.areaStyle= { opacity: 0.3};
            obj.showSymbol = false;
            obj.smooth = true;
            series.push(obj);
        }

        return { title: "", data: series }
      }
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalAreaTssDistribution')
      }
    }
  }
</script>

<style>
  .echarts {
    width: 100%;
    height: 40vh;
  }
</style>